import { PackagingParentDto } from '../packaging-parent-dto';

export class PackagingUnitParentDto extends PackagingParentDto {
    packagingTypeId?: number;
    fillingGoodId?: number;
    fillingGoodName?: string;
    fillingGoodCategoryId?: number;
    fillingGoodCategoryName?: string;
    fillingGoodTypeId?: number;
    fillingGoodTypeName?: string;
    packagingQuantity?: number;
    packagingVolume?: number;
}
